import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../../config/baseUrl";
import empty from "../../assets/images/empty-box.png";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import moment from "moment";
export default function Reviews() {
  const [review, setReview] = useState([]);
  const [selectedReview, setSelectedReview] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/student`,
        {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        }
      );
      setReview(response.data.data);
    } catch (error) {
      console.log("error", error);
    }
  };
  const handleStatusChange = async (id, newStatus) => {
    try {
      await axios.patch(`${baseUrl}/student/${id}`,
        { status: newStatus },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        }
      );

      // ✅ Update the specific review locally
      setReview((prevReviews) =>
        prevReviews.map((rev) =>
          rev._id === id ? { ...rev, status: newStatus } : rev
        )
      );

      toast.success("Status updated successfully!");
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Failed to update status. Please try again.");
    }
  };
  const handleDelete = async (id) => {
    try {
      await axios.delete(`${baseUrl}/student/${id}`, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });

      // Remove deleted item from state
      setReview((prevReviews) => prevReviews.filter((rev) => rev._id !== id));

      toast.success("Deleted successfully!");
    } catch (error) {
      console.error("Error deleting:", error);
      toast.error("Failed to delete. Please try again.");
    }
  };



  return (
    <>
      <section className="main-sec">
        <div className="row">
          <div className="col-lg-6">
            <div className="dashboard-title">
              <h4 className="dash-head">
                <i className="fa fa-chart-bar me-2" />
                Reviews
              </h4>
            </div>
            <div className="custom-bredcump">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Review List
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="col-lg-12">
            <div className="cards bus-list">
              <div className="bus-filter">
                <div className="row ">
                  <div className="col-lg-6">
                    <h5 class="card-title">Review List</h5>
                  </div>
                </div>
              </div>
              <div className="table table-responsive custom-table">
                <table className="table table-borderless">
                  <thead>
                    <tr>
                      <th>SN</th>
                      <th>By</th>
                      <th>Review</th>
                      <th>Rating</th>
                      <th>Date</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {review.length === 0 ? (
                      <tr>
                        <td colSpan="6" className="py-5 text-center">
                          <img src={empty} alt="" width="200px" />
                          <h4 className="py-2">No Reviews found!</h4>
                        </td>
                      </tr>
                    ) : (
                      review?.map((rev, i) => {
                        return (
                          <tr key={rev?.id}>
                            <td>{i + 1}</td>
                            <td>{rev?.name}</td>
                            <td>{rev?.student_desc}</td>
                            <td className="text-warning">
                              {Array.from({ length: +rev?.rating }, (_, i) => (
                                <i key={i} className="fa fa-star ms-1" />
                              ))}
                            </td>
                            <td className="">
                              {moment(rev?.createdAt).format("lll")}
                            </td>
                            <td>
                              <select
                                value={rev?.status}
                                onChange={(e) => handleStatusChange(rev?._id, e.target.value)}
                                className={
                                  rev.status === "active"
                                    ? "form-select form-select-sm text-primary"
                                    : "form-select form-select-sm text-danger"
                                }
                              >
                                <option value="active">Showing</option>
                                <option value="inactive">Hidden</option>
                              </select>
                            </td>

                            <td>
                              <div className="action-buttons">
                                <button
                                  className="action-btn edit-btn"
                                  onClick={() => {
                                    setSelectedReview(rev);
                                    setIsModalOpen(true);
                                  }}
                                >
                                  <i className="fa fa-eye"></i>
                                  <span className="tooltip-text">View</span>
                                </button>

                                <button
                                  className="action-btn delete-btn"
                                  onClick={() => handleDelete(rev._id)}
                                >
                                  <i className="fa fa-trash"></i>
                                  <span className="tooltip-text">Delete</span>
                                </button>

                              </div>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>

      {isModalOpen && selectedReview && (
        <div className="custom-modal-wrapper">
          <div className="custom-modal-backdrop" onClick={() => setIsModalOpen(false)}></div>
          <div className="custom-modal-box">
            <div className="custom-modal-header">
              <h4>Review Details</h4>
              <button className="close-btn" onClick={() => setIsModalOpen(false)}>&times;</button>
            </div>
            <div className="custom-modal-body">
              <div className="review-image">
                <img
                  src={`${baseUrl}/${selectedReview.student_photo}`}
                  alt={selectedReview.name}
                  onError={(e) => (e.target.src = "/placeholder.png")}
                />
              </div>
              <div className="review-details">
                <p><strong>Name:</strong> {selectedReview.name}</p>
                <p><strong>Description:</strong> {selectedReview.student_desc}</p>
                <p><strong>Rating:</strong> {selectedReview.rating} ⭐</p>
                <p><strong>Status:</strong> <span className={`status-tag ${selectedReview.status}`}>{selectedReview.status}</span></p>
                <p><strong>Created At:</strong> {new Date(selectedReview.createdAt).toLocaleString()}</p>
              </div>
            </div>
            <div className="custom-modal-footer">
              <button className="btn btn-secondary" onClick={() => setIsModalOpen(false)}>Close</button>
            </div>
          </div>
        </div>
      )}


      <style>{`
.custom-modal-wrapper {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1050;
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-modal-box {
  background: #fff;
  border-radius: 12px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  animation: fadeIn 0.3s ease;
  z-index: 1051;
}

.custom-modal-header {
  padding: 16px 24px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #ddd;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.custom-modal-header h4 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.close-btn {
  background: transparent;
  border: none;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  color: #777;
  transition: color 0.2s ease;
}

.close-btn:hover {
  color: #000;
}

.custom-modal-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px 24px;
}

.review-image img {
  width: 100%;
  border-radius: 8px;
  object-fit: cover;
  max-height: 250px;
}

.review-details p {
  margin-bottom: 8px;
  font-size: 15px;
  color: #333;
}

.status-tag {
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
  text-transform: capitalize;
}

.status-tag.active {
  background-color: #d1f7d1;
  color: #2e7d32;
}

.status-tag.inactive {
  background-color: #fddede;
  color: #c62828;
}

.custom-modal-footer {
  padding: 16px 24px;
  background-color: #fafafa;
  text-align: right;
  border-top: 1px solid #eee;
}

@keyframes fadeIn {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}


  
  `}</style>
    </>
  );
}
